import React, { useState, useEffect } from 'react'


import { styled, useTheme, alpha } from '@mui/material/styles';
import { Button, Box, Slide, Menu, MenuItem } from '@mui/material';
import { Avatar } from '@mui/material';
import store from '../store';
import { EVENTMODAL_action } from '../store/actions/modalAction';
import { connect } from 'react-redux';
import { Link, useNavigate, useNavigation } from 'react-router-dom';
import { CHANGE_PAGE_action } from '../store/actions/pageAction';


import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import MuiAppBar from '@mui/material/AppBar';
import { CLOSE_SIDEBAR_action, OPEN_SIDEBAR_action } from '../store/actions/sidebarAction';
import InputBase from '@mui/material/InputBase';


import SearchIcon from '@mui/icons-material/Search';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';


import SpeedDial from '@mui/material/SpeedDial';
import { LOGIN_USER_action, REGISTER_USER_action } from '../store/actions/userAction';
import { SEARCH_EVENTNAME_action, SEARCH_EVENTCREATOR_action } from '../store/actions/searchEventAction';
import { TOKEN_action } from '../store/actions/tokenAction';


const mapStateToProps = (state) => {
  return {
    page: state.pageReducer.pageName,
    user: state.userReducer,
    sidebar: state.sidebarReducer.sidebarState,
    token: state.tokenReducer.token
  }
}






const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - 240px)`,
    marginLeft: `240px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));


const ResponsiveAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `50px`,
    // marginLeft: `250px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));




const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  border: '1px solid #e0e0e0',
  '&:hover': {
    // backgroundColor: alpha(theme.palette.common.black, 0.15),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(2),
    width: 'auto',
  },
}));


const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  color: 'grey',
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));


const StyledInputBase = styled(InputBase)(({ theme }) => ({
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '14ch',
      '&:focus': {
        width: '22ch',
      },
    },
  },
}));


const Header = (props) => {
  const [isLargeScreen, setIsLargeScreen] = useState(false); // Mide el tamaño de la pantalla para hacer el diseño responsive
  const navigate = useNavigate()

  const [openResponsiveSearch, setOpenResponsiveSearch] = useState()
  const [searchTitle, setSearchTitle] = useState('')
  const [searchCreator, setSearchCreator] = useState('')

  const [anchorEl, setAnchorEl] = React.useState(null);
  const accountMenu = Boolean(anchorEl);


  const theme = useTheme();
  const [open, setOpen] = React.useState(false);


  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });


  const [modalstate, setModalstate] = useState(false);


  const openCreationEventModal = () => {
    setModalstate(modalstate);
    store.dispatch(EVENTMODAL_action(true))
  };


  const goLogin = () => {
    store.dispatch(CHANGE_PAGE_action('login'))
    store.dispatch(LOGIN_USER_action(['', '', '', '']))
    navigate('/login')
    store.dispatch(TOKEN_action(''))
    store.dispatch(LOGIN_USER_action({ email: '', nameUser: '', pass: '', resgisterDate: '', telephone: '', userID: '' }))
    store.dispatch(REGISTER_USER_action({ email: '', nameUser: '', pass: '', resgisterDate: '', telephone: '', userID: '' }))
  }

  const goProfile = () => {
    setAnchorEl(null)
    store.dispatch(CHANGE_PAGE_action('perfil'))
    navigate('/perfil')
  }


  const handleToggleSidebar = () => {
    if (props.sidebar != undefined && props.sidebar == true) {
      store.dispatch(CLOSE_SIDEBAR_action())
      setOpen(false)
    } else {
      store.dispatch(OPEN_SIDEBAR_action())
      setOpen(true)
    }
  };

  const goBack = () => { // Vuelve al inicio y ajusta el sidebar a colorear al icono correcto
    navigate('/')
    store.dispatch(CHANGE_PAGE_action('inicio'))
  }


  const [modalCreateEvent, setModalCreateEvent] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 960); // set the breakpoint here
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const SearchTitle = (event) => {
    setSearchTitle(event.target.value)
    store.dispatch(SEARCH_EVENTNAME_action(event.target.value))
  }

  const SearchCreator = (event) => {

    setSearchCreator(event.target.value)
    store.dispatch(SEARCH_EVENTCREATOR_action(event.target.value))
  }

  return (
    <>
    {/* {console.log("header")}
    {console.log(JSON.parse(localStorage.getItem('userData')).avatar)} */}
      {isLargeScreen ?
        (
          <>
            {props.actualPage === 'eventdetails' ? (
              <>
                <AppBar elevation={0} position="fixed" open={false}>
                  <Toolbar>


                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      onClick={() => { navigate('/') }}
                      edge="start"
                      sx={{ mr: 2 }}
                      style={{ display: (openResponsiveSearch ? 'none' : null) }}
                    >
                      <KeyboardArrowLeftIcon style={{ fontSize: 24 }} />
                    </IconButton>


                    <Typography variant="h6" noWrap component="div" marginRight={8} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                      Detalles del Evento
                    </Typography>






                    {/* <Box sx={{ textAlign: 'end', flexGrow: 1 }}>




                      <IconButton onClick={(event) => { setAnchorEl(event.currentTarget) }} sx={{ p: 0 }} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                        <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
                      </IconButton>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={accountMenu}
                        onClose={() => { setAnchorEl(null) }}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                      >


                        <MenuItem onClick={goLogin}>
                          <Link to={'/login'}>Mi Perfil</Link>
                        </MenuItem>
                        <MenuItem onClick={() => { setAnchorEl(null) }}>Cerrar Sesión</MenuItem>
                      </Menu>
                    </Box> */}


                  </Toolbar>
                </AppBar>
              </>
            ) : props.actualPage === 'createevent' ? (
              <>
                <AppBar elevation={1} position="fixed" open={false}>
                  <Toolbar>


                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      onClick={goBack}
                      edge="start"
                      sx={{ mr: 2 }}
                    >
                      <KeyboardArrowLeftIcon style={{ fontSize: 24 }} />
                    </IconButton>


                    <Typography variant="h6" noWrap fontFamily={'Poppins'} component="div" marginRight={8} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                      Socialize
                    </Typography>

                    {/* <Box sx={{ textAlign: 'end', flexGrow: 1 }}>

                      <IconButton onClick={(event) => { setAnchorEl(event.currentTarget) }} sx={{ p: 0 }} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                        <Avatar alt={props.user.nombre} src="/static/images/avatar/2.jpg" />
                      </IconButton>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={accountMenu}
                        onClose={() => { setAnchorEl(null) }}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                      >


                        <MenuItem onClick={goLogin}>
                          <Link to={'/login'}>Mi Perfil</Link>
                        </MenuItem>
                        <MenuItem onClick={() => { setAnchorEl(null) }}>Cerrar Sesión</MenuItem>
                      </Menu>
                    </Box> */}


                  </Toolbar>
                </AppBar>
              </>
            ) : props.actualPage === 'profile' ? (
              <>
                <AppBar elevation={1} position="fixed" open={props.sidebar != undefined ? props.sidebar : open}>

                  <Toolbar>


                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      onClick={handleToggleSidebar}
                      edge="start"
                      sx={{ mr: 2 }}
                      style={{ display: (openResponsiveSearch ? 'none' : null) }}
                    >
                      <MenuIcon />
                    </IconButton>


                    <Typography variant="h6" noWrap component="div" marginRight={8} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                      Perfil
                    </Typography>

                    <Box sx={{ textAlign: 'end', flexGrow: 1 }} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                      <Button sx={{ color: '#fff', marginRight: 6 }}
                        startIcon={<AddOutlinedIcon />}
                        onClick={() => { navigate('/createevent') }}
                      >
                        CREAR EVENTO
                      </Button>
                    </Box>

                    <Box sx={{ textAlign: 'end', flexGrow: 0 }}>

                      <IconButton onClick={(event) => { setAnchorEl(event.currentTarget) }} sx={{ p: 0 }} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                      <Avatar alt={props.user.nombre} src={(localStorage.getItem('userData') && `${JSON.parse(localStorage.getItem('userData')).avatar}` + "?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D")} />
                      </IconButton>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={accountMenu}
                        onClose={() => { setAnchorEl(null) }}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                      >


                        <MenuItem onClick={goProfile}>
                          Mi Perfil
                        </MenuItem>
                        <MenuItem onClick={goLogin}>Cerrar Sesión</MenuItem>
                      </Menu>
                    </Box>


                  </Toolbar>
                </AppBar>
              </>
            ) : (
              <>
                <AppBar elevation={0} position="fixed" open={props.sidebar != undefined ? props.sidebar : open}
                  style={{ backgroundColor: 'white' }}>

                  <Toolbar>


                    <IconButton
                      aria-label="open drawer"
                      onClick={handleToggleSidebar}
                      edge="start"
                      sx={{ mr: 2 }}
                      style={{ display: (openResponsiveSearch ? 'none' : null) }}
                    >
                      <MenuIcon />
                    </IconButton>


                    {/* BTN SALIR DE SEARCH RESPONSIVE */}
                    <IconButton
                      aria-label="open drawer"
                      onClick={() => { setOpenResponsiveSearch(false) }}
                      edge="start"
                      sx={{ mr: 2 }}
                      style={{ display: (openResponsiveSearch ? null : 'none') }}
                    >
                      <KeyboardArrowLeftIcon />
                    </IconButton>


                    <Typography variant="h6" noWrap fontFamily={'Poppins'} component="div" marginRight={8} style={{ color: 'black', display: (openResponsiveSearch ? 'none' : null) }}>
                      Socialize
                    </Typography>


                    {/* <Search style={{ display: (isLargeScreen ? null : 'none') }}>
                      <SearchIconWrapper>
                        <SearchIcon />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder="Buscar evento..."
                        inputProps={{ 'aria-label': 'search' }}
                        value={searchTitle}
                        onChange={SearchTitle}
                      />
                    </Search> */}


                    {/* <Search style={{ display: (isLargeScreen ? null : 'none') }}>
                      <SearchIconWrapper>
                        <SearchIcon />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder="Buscar por creador..."
                        inputProps={{ 'aria-label': 'search' }}
                        value={searchCreator}
                        onChange={SearchCreator}
                      />
                    </Search> */}


                    {/* BTN SEARCH RESPONSIVE */}
                    <Button size=''
                      sx={{ color: '#fff', marginRight: 6, borderRadius: 60 }}
                      style={{ display: ((openResponsiveSearch || isLargeScreen) ? 'none' : null) }}
                      startIcon={<SearchIcon />}
                      onClick={() => { setOpenResponsiveSearch(true) }}>
                    </Button>
                    {props.user.email !== '' ? (

                      <Box sx={{ textAlign: 'end', flexGrow: 1 }} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                        <Button sx={{ color: '#fff', marginRight: 6 }}
                          startIcon={<AddOutlinedIcon />}
                          onClick={() => { navigate('/createevent') }}
                          style={{ backgroundColor: '#1976d2' }}
                        >
                          CREAR EVENTO
                        </Button>
                      </Box>
                    ) : (
                      <Box sx={{ textAlign: 'end', flexGrow: 1 }} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                        <Button sx={{ color: '#fff', marginRight: 6 }}
                          startIcon={<AddOutlinedIcon />}
                          onClick={() => { navigate('/login') }}
                          style={{ backgroundColor: '#1976d2' }}
                        >
                          CREAR EVENTO
                        </Button>
                      </Box>
                    )}

                    <Box sx={{ textAlign: 'end', flexGrow: 0 }}>
                      {props.user.email !== '' && props.user.email !== undefined ? (
                        <>
                          <IconButton onClick={(event) => { setAnchorEl(event.currentTarget) }} sx={{ p: 0 }} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                          <Avatar alt={props.user.nombre} src={(localStorage.getItem('userData') && `${JSON.parse(localStorage.getItem('userData')).avatar}` + "?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D")} />
                          </IconButton>

                          <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={accountMenu}
                            onClose={() => { setAnchorEl(null) }}
                            MenuListProps={{
                              'aria-labelledby': 'basic-button',
                            }}
                          >
                            <MenuItem onClick={goProfile}>
                              Mi Perfil
                            </MenuItem>
                            <MenuItem onClick={goLogin}>Cerrar Sesión</MenuItem>
                          </Menu>
                        </>
                      ) : (
                        <Button variant='outlined' onClick={() => { navigate('/login') }}>Ingresar</Button>
                      )}
                    </Box>


                    {/* <Search style={{ display: ((openResponsiveSearch) ? null : 'none'), width: '100%' }}>
                      <SearchIconWrapper>
                        <SearchIcon />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder="Buscar evento..."
                        inputProps={{ 'aria-label': 'search' }}
                      />
                    </Search> */}
                  </Toolbar>
                </AppBar>
              </>

            )}


          </>


        ) : (


          <>
            {props.actualPage === 'eventdetails' ? (
              <>
                <AppBar elevation={1} position="fixed" open={false}>
                  <Toolbar>


                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      onClick={() => { navigate('/') }}
                      edge="start"
                      sx={{ mr: 2 }}
                      style={{ display: (openResponsiveSearch ? 'none' : null) }}
                    >
                      <KeyboardArrowLeftIcon style={{ fontSize: 24 }} />
                    </IconButton>


                    <Typography variant="h6" noWrap component="div" marginRight={8} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                      Detalles del Evento
                    </Typography>






                    {/* <Box sx={{ textAlign: 'end', flexGrow: 1 }}>

                      <IconButton onClick={(event) => { setAnchorEl(event.currentTarget) }} sx={{ p: 0 }} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                        <Avatar alt={props.user.nombre} src="/static/images/avatar/2.jpg" />
                      </IconButton>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={accountMenu}
                        onClose={() => { setAnchorEl(null) }}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                      >
                        <MenuItem onClick={goLogin}>
                          <Link to={'/login'}>Mi Perfil</Link>
                        </MenuItem>
                        <MenuItem onClick={() => { setAnchorEl(null) }}>Cerrar Sesión</MenuItem>
                      </Menu>
                    </Box> */}


                  </Toolbar>
                </AppBar>
              </>
            ) : props.actualPage === 'createevent' ? (
              <>
                <AppBar elevation={1} position="fixed" open={false}>
                  <Toolbar>


                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      onClick={goBack}
                      edge="start"
                      sx={{ mr: 2 }}
                    >
                      <KeyboardArrowLeftIcon style={{ fontSize: 24 }} />
                    </IconButton>


                    {/* <Typography variant="h6" noWrap component="div" marginRight={8} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                      EventEase
                    </Typography> */}

                    <Box sx={{ textAlign: 'end', flexGrow: 1 }}>

                      <IconButton onClick={(event) => { setAnchorEl(event.currentTarget) }} sx={{ p: 0 }} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                      {/* <Avatar alt={props.user.nombre} src={(localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData')).avatar.includes('blob')) ? `${JSON.parse(localStorage.getItem('userData')).avatar}` : `data:image/png;base64,${JSON.parse(localStorage.getItem('userData')).avatar}`} /> */}
                      <Avatar alt={props.user.nombre} src={(localStorage.getItem('userData') && `${JSON.parse(localStorage.getItem('userData')).avatar}` + "?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D")} />
                      
                      </IconButton>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={accountMenu}
                        onClose={() => { setAnchorEl(null) }}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                      >


                        <MenuItem onClick={() => { setAnchorEl(null) }}>
                          Mi Perfil
                        </MenuItem>
                        <MenuItem onClick={goLogin}>Cerrar Sesión</MenuItem>
                      </Menu>
                    </Box>


                  </Toolbar>
                </AppBar>
              </>
            ) : (
              <ResponsiveAppBar elevation={1} position="fixed" open={props.sidebar != undefined ? props.sidebar : open}>
                <Toolbar>



                  {/* BTN SALIR DE SEARCH RESPONSIVE */}
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={() => { setOpenResponsiveSearch(false) }}
                    edge="start"
                    sx={{ mr: 2 }}
                    style={{ display: (openResponsiveSearch ? null : 'none') }}
                  >
                    <KeyboardArrowLeftIcon />
                  </IconButton>


                  <Typography variant="h6" noWrap component="div" style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                    HiSocialize
                  </Typography>



                  {!openResponsiveSearch && (
                    <div style={{ marginLeft: 'auto' }}>
                      {props.user.email !== '' && props.user.email !== undefined ? (
                        <>
                          <IconButton onClick={(event) => { setAnchorEl(event.currentTarget) }} sx={{ p: 0 }} style={{ display: (openResponsiveSearch ? 'none' : null) }}>
                            <Avatar alt={props.user.nombre} src={(localStorage.getItem('userData') && `${JSON.parse(localStorage.getItem('userData')).avatar}` + "?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D")} />
                          </IconButton>
                          <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={accountMenu}
                            onClose={() => { setAnchorEl(null) }}
                            MenuListProps={{
                              'aria-labelledby': 'basic-button',
                            }}
                          >
                            <MenuItem onClick={goProfile}>
                              Mi Perfil
                            </MenuItem>
                            <MenuItem onClick={goLogin}>Cerrar Sesión</MenuItem>
                          </Menu>
                        </>
                      ) : (
                        <Button style={{ color: 'white' }} variant='outlined' onClick={() => { navigate('/login') }}>Iniciar sesión</Button>
                      )}
                    </div>
                  )}







                  {/* {openResponsiveSearch && (

                    <Search style={{ width: '100%' }}>
                      <SearchIconWrapper>
                        <SearchIcon style={{ color: 'grey' }} />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder="Buscar evento..."
                        inputProps={{ 'aria-label': 'search' }}
                      />
                    </Search>
                  )} */}
                </Toolbar>
              </ResponsiveAppBar>
            )}
          </>
        )}




    </>
  )
}


export default connect(mapStateToProps)(Header)
